import { keys } from 'ramda'
import React from 'react'

import { useLocation, useSubdomain } from '../../../../utils/contexts/UrlProvider'
import { useQrcodePlaceId } from '../../_load/QrcodeLoader'
import Loading from '../../../../components/helpers/Loading'

const formIdsToRedirect = {
  gpa: '242ff6ab-5771-4131-8f21-ec19ac20dcba',
  carrefour: '26171789-eece-4710-abcd-32741bc7fe36',
  jactofacilities: 'ec6e6c91-c5a9-41a1-8a7d-24d498d3bcff',
  mktgpa: '8b5ff6a7-ddb0-4983-b2aa-c208bd2bc6ad',
  jactoclean: '7e6ff83d-b8ac-42d3-a56a-bfaf1526a611'
}

const formIdsWithPlaceIdsToRedirect = {
  jactofacilities: {
    form: '45bf6ba0-f373-4a76-add2-53bc3dc6b080',
    placeIds: [113, 114, 115, 116]
  },
  anylife: {
    form: 'd72ef632-202e-496f-bc41-dc8ae6489752',
    placeIds: [164]
  }
}

const redirectToForm = (origin, form, placeId) => {
  const url = `${origin}/public/forms/${form}/execution?placeId=${placeId}`
  window.location.href = url
}

const CustomWorkspaceRedirect = ({ children }) => {
  const workspace = useSubdomain()
  const { origin } = useLocation()
  const placeId = useQrcodePlaceId()

  if (keys(formIdsWithPlaceIdsToRedirect).includes(workspace)) {
    const config = formIdsWithPlaceIdsToRedirect[workspace]
    if (!!config?.placeIds && config.placeIds.includes(placeId)) {
      redirectToForm(origin, config.form, placeId)
      return <Loading />
    }
  }
  if (keys(formIdsToRedirect).includes(workspace)) {
    redirectToForm(origin, formIdsToRedirect[workspace], placeId)
    return <Loading />
  }

  return children
}

export default CustomWorkspaceRedirect
